import React from "react";
import { Link } from "react-router-dom";

const stories = [
  {
    id: 1,
    name: "From Struggle to Success: Aditya's Journey With Us",
    img: "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story1.jpeg"
  },
  {
    id: 2,
    name: "Bridging the Digital Divide : Madhubani Education Center",
    img: "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story2a.jpeg"
  },
  {
    id: 3,
    name: "Empowering Women : An Initiative",
    img: "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story3.jpeg"
  },
  {
    id: 4,
    name: "Empowering Female Artists: Kala Sangini Initiative",
    img: "https://ik.imagekit.io/bhavishya/web-final/Programs/kala/kala11.jpeg?updatedAt=1739992158886"
  },
  {
    id: 5,
    name: "Bhavishya NGO's COVID-19 Relief Efforts: A Success Story",
    img: "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5a.jpeg"
  },
  {
    id: 6,
    name: "Bhavishya NGO's 'Sab Padhe Sab Badhe' Initiative: Empowering Education in Noida",
    img: "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story6.jpeg"
  },
  {
    id: 7,
    name: "Bhavishya NGO: A Beacon of Hope",
    img: "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story7b.jpeg"
  }
];

const SuccessStory = () => {
  return (
    <div className="w-full min-h-screen bg-[#FAFAFA]">
      {/* Header Section */}
      <div className='w-full min-h-[280px] px-4 sm:px-[50px] py-[40px] sm:py-[60px] flex flex-col items-center justify-center gap-[12px] bg-[#EE645A] font-poppins text-center text-white'>
        <h1 className='font-semibold text-[28px] sm:text-[40px]'>
          Success Stories
        </h1>

        <p className='h-auto mt-3 font-normal text-[16px] sm:text-[20px] text-[#FFFFFFCC]'>
          Turning Challenges into Achievements
        </p>

        <p className='max-w-[900px] h-auto mb-0 font-normal text-[14px] sm:text-[18px] mt-3 text-[#FFFFFFCC]'>
          Real stories of transformation and hope from individuals whose lives have been changed through our initiatives
        </p>
      </div>

      {/* Stories Grid */}
      <div className="max-w-[1320px] mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
          {stories.map((story) => (
            <Link 
              to={`/story/${story.id}`} 
              key={story.id} 
              className="w-full max-w-[424px] rounded-[16px] overflow-hidden shadow-[0_4px_6px_-4px_rgba(0,0,0,0.1),0_10px_15px_-4px_rgba(0,0,0,0.1)] block hover:shadow-xl transition-all duration-300 transform hover:scale-105 group"
            >
              {/* Image Container */}
              <div className="relative h-[280px] overflow-hidden bg-gray-200">
                <img 
                  src={story.img} 
                  alt={story.name} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              {/* Content Section */}
              <div className="bg-white p-6">
                <h2 className="text-[18px] sm:text-[20px] font-bold text-[#000000] leading-tight line-clamp-2 group-hover:text-[#EE645A] transition-colors duration-300">
                  {story.name}
                </h2>
                
                {/* Read More */}
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-[#EE645A] text-[14px] font-semibold">
                    Read Story
                  </span>
                  <svg className="w-5 h-5 text-[#EE645A] group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      {/* <div className="bg-[#EE645A] text-white py-12 px-4 mt-8">
        <div className="max-w-[1320px] mx-auto text-center">
          <h2 className="text-[28px] sm:text-[36px] font-bold mb-4">
            Have a Story to Share?
          </h2>
          <p className="text-[16px] sm:text-[18px] text-[#FFFFFFCC] mb-6 max-w-[700px] mx-auto">
            Your journey of transformation matters. Share how Bhavishya has made a difference in your life.
          </p>
          <button className="px-8 py-3 bg-white text-[#EE645A] font-bold rounded-full hover:bg-gray-100 transition-colors duration-300">
            Share Your Story
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default SuccessStory;